import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { EntityDataService, EntityDataModule } from '@ngrx/data';
import { environment } from '../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { entityConfig } from './entity-metadata';
import { InputTypesDataService } from './services/data/input-types-data.service';
import { RdSAPLookUpCodesDataService } from './services/data/rd-sap-lookup-codes-data.service';
import { AssetRdSAPDetailsService } from './services/data/rdsap-survey-details-data.service';
import { RdSAPInfoDataService } from './services/data/rd-sap-info-data.service';
import { RdSAPHealthDataService } from './services/data/rd-sap-health-data.service';

// Define the custom state module
@NgModule({
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    EntityDataModule.forRoot(entityConfig),
    environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 25 })
  ],
  providers: [
    InputTypesDataService,
    RdSAPLookUpCodesDataService,
    AssetRdSAPDetailsService,
    RdSAPInfoDataService,
    RdSAPHealthDataService,
  ]
})
export class CoreStateModule {
  constructor(
    entityDataService: EntityDataService,
    inputTypesDataService: InputTypesDataService,
    rdSAPLookUpCodesDataService: RdSAPLookUpCodesDataService,
    assetRdSAPDetailsService: AssetRdSAPDetailsService,
    rdSAPInfoDataService: RdSAPInfoDataService,
    rdSAPHealthDataService: RdSAPHealthDataService,
  ) {
    // Register the custom data services for the entities
    entityDataService.registerService('CustomInputTypes', inputTypesDataService);
    entityDataService.registerService('RdSAPLookUpCodes', rdSAPLookUpCodesDataService);
    entityDataService.registerService('RdSAPDetails', assetRdSAPDetailsService);
    entityDataService.registerService('RdSAPInfo', rdSAPInfoDataService);
    entityDataService.registerService('RdSAPHealth', rdSAPHealthDataService);
  }
}
